import React from "react";
import classnames from "classnames";
import { usePagination } from "../../hooks/usePagination";
import arrow from "../../assets/icons/arrow-right.svg";
import "./index.css";
const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];

  return (
    <ul
      className={classnames("pagination-container flex justify-center py-2  ", {
        [className]: className,
      })}
    >
      {/* Left navigation arrow */}
      <button
        className={classnames(
          " font-bold border-[1px] border-[#0A2341] p-2 rounded-lg mx-2 cursor-pointer disabled:opacity-15",
          {
            disabled: currentPage === 1,
          }
        )}
        disabled={currentPage === 1}
        onClick={onPrevious}
      >
        <img src={arrow} alt="" className="" />
      </button>
      {paginationRange.map((pageNumber, i) => {
        if (pageNumber === "...") {
          return (
            <li key={i} className="pagination-item dots">
              &#8230;
            </li>
          );
        }
        if (pageNumber === currentPage) {
          return (
            <li key={i} className="pagination-item dots">
              <input
                type="text"
                className="bg-white w-9 h-9 rounded-lg text-center"
                defaultValue={pageNumber}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    onPageChange(Number(e.target.value));
                  }
                }}
              />
            </li>
          );
        }

        // Render our Page Pills
        return (
          <li
            key={i}
            className={classnames("pagination-item")}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}
      {/*  Right Navigation arrow */}
      <button
        className={classnames(
          " font-bold border-[1px] border-[#0A2341] p-2 rounded-lg mx-2 cursor-pointer disabled:opacity-15"
        )}
        disabled={currentPage === lastPage}
        onClick={onNext}
      >
        <img src={arrow} alt="" className="rotate-180 " />
      </button>
    </ul>
  );
};

export default Pagination;
